export function isDuplicateNavigation(error) {
  if (!error) return false
  if (error.name === 'NavigationDuplicated') return true
  return error._isRouter === true && error.type === 16
}

export function ignoreDuplicateNavigation(error) {
  if (isDuplicateNavigation(error)) return
  throw error
}

export function replaceVideoLessonRoute(
  router,
  { courseId, unitId, lessonId }
) {
  return router
    .replace({
      path: `/video-play/${courseId}/${unitId}/${lessonId}`
    })
    .catch(ignoreDuplicateNavigation)
}
